import React from 'react'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import styled from 'styled-components'
import paulinabanner from '@/images/paulina-acevedo-menanteau.jpg'

const StImgWrap = styled.div`
  padding-bottom: 33%;
  height: 0;
  position: relative;
  .wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .gatsby-image-wrapper {
    display: block;
  }
`

const Profilebar = ({ nombre, twitterBanner }) => {
  const twitterbanner = getImage(twitterBanner)
  if (twitterBanner) {
    return (
      <StImgWrap className="mt-16">
        {nombre === 'Paulina Alejandra Acevedo Menanteau' ? (
          <img
            className="absolute object-cover w-full h-full"
            src={paulinabanner}
            nombre={nombre}
          />
        ) : twitterBanner && twitterBanner.childImageSharp ? (
          <div className="wrap">
            <GatsbyImage
              className="absolute object-cover w-full h-full"
              image={twitterbanner}
              alt={nombre}
            />
          </div>
        ) : (
          <div className="wrap">
            <StaticImage
              src="https://source.unsplash.com/collection/40236268/1600x400"
              className="absolute object-cover w-full h-full"
              alt={nombre}
            />
          </div>
        )}
      </StImgWrap>
    )
  }
  return (
    <StImgWrap className="mt-16 sm:mt-0">
      <div className="wrap">
        <StaticImage
          src="https://source.unsplash.com/collection/40236268/1600x400"
          className="absolute object-cover w-full h-full "
          alt={nombre}
        />
      </div>
    </StImgWrap>
  )
}

export default Profilebar
